<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'

import { useTableUsers } from '../model/table-users.hook'
import UserRowActions from './UserRowActions.vue'

defineOptions({
  name: 'TableUsers',
})

const {
  users,
  isLoading,
  hasUsers,
  meta,
  perPageOptions,
  formatDateTime,
  getRoles,
  getStatus,
  getTeams,
  openUser,
  setChangePage,
  setChangePerPage,
} = useTableUsers()
</script>

<template>
  <div class="table-users">
    <AppTable
      class="rounded-table"
      :meta="meta"
      :per-page-options="perPageOptions"
      :loading="isLoading"
      @change:page="setChangePage"
      @change:per-page="setChangePerPage"
    >
      <template #head>
        <AppTr>
          <AppTh class="text-center table-users__id-cell">
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              #
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Name
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Email
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Roles
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Team
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Status
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Email verified at
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Created at
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Updated at
            </AppText>
          </AppTh>
          <AppTh class="table-users__actions-cell" />
        </AppTr>
      </template>

      <template
        v-if="hasUsers"
        #body
      >
        <AppTr
          v-for="user in users"
          :key="user.id"
        >
          <AppTd class="medium text-center table-users__id-cell">
            <button
              type="button"
              class="table-users__cell-link"
              :aria-label="`Open ${user.name}`"
              @click="openUser(user)"
            >
              <AppText
                name="body1"
                color="blue-600"
              >
                {{ user.id }}
              </AppText>
            </button>
          </AppTd>
          <AppTd class="medium">
            <button
              type="button"
              class="table-users__cell-link"
              :aria-label="`Open ${user.name}`"
              @click="openUser(user)"
            >
              <AppText
                name="body1"
                color="blue-600"
              >
                {{ user.name }}
              </AppText>
            </button>
          </AppTd>
          <AppTd class="medium">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ user.email }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ getRoles(user) || '—' }}
            </AppText>
          </AppTd>
          <AppTd class="medium table-users__team-cell">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ getTeams(user) || '—' }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ getStatus(user) }}
            </AppText>
          </AppTd>
          <AppTd class="medium table-users__date-cell">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ formatDateTime(user.email_verified_at) }}
            </AppText>
          </AppTd>
          <AppTd class="medium table-users__date-cell">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ formatDateTime(user.created_at) }}
            </AppText>
          </AppTd>
          <AppTd class="medium table-users__date-cell">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ formatDateTime(user.updated_at) }}
            </AppText>
          </AppTd>
          <AppTd class="zero-padding table-users__actions-cell">
            <UserRowActions :user="user" />
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
  </div>
</template>

<style scoped lang="scss" src="./TableUsers.scss" />
